/**
 * AnimationControl — Reduced motion toggle with system preference indicator.
 *
 * @module components/accessibility/AnimationControl
 */
import React from 'react';
import { Box, FormControlLabel, Switch, Typography } from '@mui/material';
import { Trans } from '@lingui/react/macro';
import { useAccessibilitySettings } from '../../hooks/useAccessibilitySettings';

export const AnimationControl: React.FC = () => {
  const { animationsEnabled, prefersReducedMotion, updateSettings } =
    useAccessibilitySettings();

  const handleToggle = () => {
    updateSettings({ animationsEnabled: !animationsEnabled });
  };

  return (
    <Box>
      <FormControlLabel
        control={
          <Switch
            checked={!animationsEnabled}
            onChange={handleToggle}
            inputProps={{ 'aria-label': 'Reduce animations' }}
          />
        }
        label={
          <Box>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              <Trans>Reduce Animations</Trans>
            </Typography>
            <Typography variant="caption" sx={{ display: 'block', mt: 0.25 }} color="text.secondary">
              {animationsEnabled ? (
                <Trans>All animations are active</Trans>
              ) : (
                <Trans>Animations are reduced</Trans>
              )}
              {prefersReducedMotion && (
                <>
                  {' '}
                  (<Trans>system preference</Trans>)
                </>
              )}
            </Typography>
          </Box>
        }
        sx={{ ml: 0, alignItems: 'flex-start' }}
      />
    </Box>
  );
};

export default AnimationControl;
